import { FaPhoneAlt, FaArrowRight } from "react-icons/fa";
import { IMAGES } from "../../data/images";
import { BOOKING_URL, PHONE_TEL, PHONE_DISPLAY } from "../../data/config";
import "./common.css";

export default function CtaBanner() {
  return (
    <section
      className="cta-banner"
      style={{ backgroundImage: `linear-gradient(rgba(12,12,12,.9),rgba(12,12,12,.78)), url(${IMAGES.road})` }}
    >
      <div className="container cta-inner">
        <div>
          <span className="subtitle">Ready to ride?</span>
          <h2>Book Your Taxi in Just a Few Clicks</h2>
          <p>Fast, safe and affordable rides available 24/7. Your journey starts here.</p>
        </div>
        <div className="cta-actions">
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Book online Now <FaArrowRight />
          </a>
          <a href={PHONE_TEL} className="btn btn-outline">
            <FaPhoneAlt /> {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
}
